import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function CoinDetailsNew() {
  return (
     <>
         <div>
            <Topheader colorbox="newfaq_header_color" title="Coin Details"/>
           <div className="top-container container">
             <img
               src={require("../../images/coins-detail/mainbanner.webp")}
               alt="main banner"
               className="img-fluid py-4"
             />
           </div>
           <div className="container">
             <div className="">
               <div className={style.sec2_text1}>
                 What are coins?
               </div>
               <div className={style.sec2_text2}>
                Coins is a currency that a user earns when they participate in a popular game hand where in commission has been charged by the operator for the facilitation of the game services. Convenience fee charged on the commission or rake is not included in coin calculation.
               </div>
             </div>
           </div>
            <div className={style.sec3}>
    <div className={style.sec2_text1}>
        How coins are generated? 
    </div>
    <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-2.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}
             />
             <div className="">
                <div className={style.sec3_box_text1}>Step 1: Play A Popular Game Hand</div>
                 <div className={style.sec3_box_text2}>Tap the icon on the HomeScreen to view all available rewards.</div>
             </div>
    </div>
     <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-1.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}

             />
             <div className="">
                <div className={style.sec3_box_text1}>Step 2: Earn Coins</div>
                 <div className={style.sec3_box_text2}>Earn coins equivalent to the rake you have generated while playing the hand.</div>
             </div>
    </div>
   </div>
         </div>
       </>
  )
}
